<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import PxbmBrowse from "./PxbmBrowse";
import PxbmEdit from "./PxbmEdit";
import PxbmForm from "./PxbmForm";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "pxbmBS",
    components: { PxbmBrowse, PxbmEdit, PxbmForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false
            }
        };
    },
    created() {
        if (this.getNoticeId) {
            this.editProps.showEdit = true;
        }
    },
    computed: {
        ...userMapGetters(["getNoticeId"]),
        compName() {
            if (this.editProps.showEdit === true) {
                return "PxbmEdit";
            } else if (this.editProps.showForm === true) {
                return "PxbmForm";
            } else {
                return "PxbmBrowse";
            }
        }
    }
};
</script>
